/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { OrganizationBillingDetailDtoModel, OrganizationBillingDetailDtoModelType } from "./OrganizationBillingDetailDtoModel"
import { OrganizationBillingDetailDtoModelSelector } from "./OrganizationBillingDetailDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  billingPlan: OrganizationBillingDetailDtoModelType;
}

/**
 * BillingPlanCancellationRequestedDtoBase
 * auto generated base class for the model BillingPlanCancellationRequestedDtoModel.
 */
export const BillingPlanCancellationRequestedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('BillingPlanCancellationRequestedDto')
  .props({
    __typename: types.optional(types.literal("BillingPlanCancellationRequestedDto"), "BillingPlanCancellationRequestedDto"),
    /** Billing plan cancellation requested */
    billingPlan: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => OrganizationBillingDetailDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class BillingPlanCancellationRequestedDtoModelSelector extends QueryBuilder {
  billingPlan(builder: string | OrganizationBillingDetailDtoModelSelector | ((selector: OrganizationBillingDetailDtoModelSelector) => OrganizationBillingDetailDtoModelSelector) | undefined) { return this.__child(`billingPlan`, OrganizationBillingDetailDtoModelSelector, builder) }
}
export function selectFromBillingPlanCancellationRequestedDto() {
  return new BillingPlanCancellationRequestedDtoModelSelector()
}

export const billingPlanCancellationRequestedDtoModelPrimitives = selectFromBillingPlanCancellationRequestedDto()
